import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { BiChevronDown, BiChevronUp, BiSearch, BiX } from 'react-icons/bi';
import { Link, useNavigate, useParams } from 'react-router';
import InvoiceSelector from '../../../Components/Invoices/PreviewInvoice/InvoiceSelector';
import { invoiceThemes } from '../../../Helper/invoiceThemes';
import styles from './InvoicePreviewer.module.css';
import tinycolor from "tinycolor2"; // For advanced color manipulation
import { MdChevronLeft } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';
import { CheckCircle2, Clock3, Mail, MessageSquare, Sparkles } from 'lucide-react';
import { BASE_URL_API } from '../../../References/URLs';
import AuthContext from '../../../store/auth-context';
import ActiveStoreContext from '../../../store/ActiveStoreContext';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const InvoicePreviewer = () => {
    const { sessionIdentifier } = useParams();
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const navigate = useNavigate()
    // console.log(activeStore)
    const [isMarkingCompleted, setIsMarkingCompleted] = useState(false)
    const [isSendingInvoice, setIsSendingInvoice] = useState(false)
    const [invoiceDataMaster, setInvoiceDataMaster] = useState({
        "sessionIdentifier": "201719293519003381173645490220250110",
        "invoiceDate": "2025-01-11",
        "dueDate": "2025-01-11",
        "invoiceNumber": "5345234",
        "clientData": {
            "clientStoreRelationIdentifier": "201719293519003381WALKIN173657378120250111",
            "clientName": "",
            "phoneNumber": "",
            "gender": "Male",
            "dateOfBirth": "",
            "ID": "2474",
            "storeIdentifier": "201719293519003381",
            "vender_email": "",
            "countryCode": "",
            "mobile": "9999648406",
            "alternateNumber": "",
            "whatsAppNumber": "",
            "salutation": "Mr.",
            "client_name": "Navneet Chandan",
            "client_email": "navneet@lokaci.com",
            "client_address": "Noida",
            "city": "",
            "state": "",
            "pincode": "",
            "client_birthday": "1999-07-25",
            "clientDoa": "",
            "added_on": "2025-01-11 11:06:21",
            "isDeleted": "0",
            "deletedOn": "0000-00-00 00:00:00",
            "deletionRemark": "",
            "registrationSource": "",
            "relatives": "[{\"relativeIdentifier\": null, \"salutation\": null, \"firstName\": null, \"middleName\": null, \"lastName\": null, \"dateOfBirth\": null, \"gender\": null, \"relationToFamilyHead\": null}]"
        },
        "productData": [
            {
                "productIdentifier": "8677d8ae-9227-478d-ae9a-2086cf118aa1",
                "identifier": "201719293519003381173644897610B5C15C0FA179FA",
                "qty": 1,
                "price": "50",
                "total": 59,
                "consultedBy": [
                    {
                        "id": "1736501472C609EFB6D1755CB1",
                        "staffName": "Shashank Sir",
                        "contribution": 100
                    }
                ],
                "servedBy": [
                    {
                        "id": "17365039830E5FE85660260C3C",
                        "staffName": "Owner Madam",
                        "contribution": 100
                    }
                ],
                "productTitle": "EYEBROW THREAD",
                "gst": "18",
                "gstValue": 9,
                "discount": 0
            },
            {
                "productIdentifier": "bf1faebf-91fe-4fe8-ab79-952b76fb8c8a",
                "identifier": "2017192935190033811736449990BD229EAFF45199A6",
                "qty": 2,
                "price": "500",
                "total": 950,
                "consultedBy": [
                    {
                        "id": "1736501472C609EFB6D1755CB1",
                        "staffName": "Shashank Sir",
                        "contribution": 100
                    }
                ],
                "servedBy": [
                    {
                        "id": "17365039830E5FE85660260C3C",
                        "staffName": "Owner Madam",
                        "contribution": 100
                    }
                ],
                "productTitle": "HALF BACK NORMAL",
                "gstValue": 0,
                "discount": 5
            }
        ],
        "discountType": "percentage",
        "tncData": [
            {
                "title": "Non refundable",
                "detail": "Can't be refunded"
            }
        ],
        "customFields": [
            {
                "fieldTitle": "Coupon",
                "calculationLogic": "subtract",
                "calculationType": "value",
                "value": 204.5
            }
        ],
        "shipmentPlaceOfSupply": "Uttar Pradesh",
        "totalAmount": 1009,
        "invoiceType": "ICICI Bank",
        "isRoundingOff": false,
        "roundOffValue": 0,
        "paymentMode": "Cash"
    })
    // Define extensive themes with metadata and customization options.. fetched 
    const themesWrapper = invoiceThemes
    const [selectedTheme, setSelectedTheme] = useState(
        {
            id: "TallyTheme",
            title: "Tally Theme",
            details: "",
            meta: {
                primaryColor: "#4CAF50",
                secondaryColor: "#F5F5F5",
                textColor: "#000000",
                primaryTextColor: "#1A1A1A",
                secondaryTextColor: "#666666",
                backgroundColor: "#FFFFFF",
                fontSize: "14px",
                fontFamily: "Arial, sans-serif"
            }
        }
    );
    const [selectedInvoiceFormat, setSelectedInvoiceFormat] = useState('Simple Invoice');
    const [palette, setPalette] = useState([
        { backgroundColor: "#FFFFFF", textColor: "#000000" },
        { backgroundColor: "#000000", textColor: "#FFFFFF" },
    ]);
    const [selectedPallete, setSelectedPallete] = useState({
        backgroundColor: '#ffffff',
        textColor: '#000000'
    })
    const [customUserColor, setCustomUserColor] = useState(null)

    const invoiceFormats = [
        { label: 'Simple Invoice', layout: 'A clean, straightforward invoice format.' },
        { label: 'Itemized Invoice', layout: 'Detailed breakdown of items and services.' },
        { label: 'Tax Invoice', layout: 'Includes tax details and calculations.' },
    ];
    const handleThemeSelect = (theme) => {
        setSelectedTheme(theme)
        console.log(theme)
    }

    const handleFormatSelect = (format) => setSelectedInvoiceFormat(format);

    const [expandedGroups, setExpandedGroups] = useState(
        themesWrapper.map(() => false) // Default: All groups collapsed
    );
    const [themeSearchTerm, setThemeSearchTerm] = useState('');

    useEffect(() => {
        setExpandedGroups((prevState) => {
            if (prevState.length === themesWrapper.length) {
                return prevState;
            }

            return themesWrapper.map((_, index) => prevState[index] ?? false);
        });
    }, [themesWrapper]);

    const normalizedThemeSearch = themeSearchTerm.trim().toLowerCase();
    const totalThemesCount = useMemo(
        () => themesWrapper.reduce((count, group) => count + (group?.themeData?.length || 0), 0),
        [themesWrapper]
    );

    const filteredThemeGroups = useMemo(() => {
        const searchTerm = normalizedThemeSearch;
        const isSearching = searchTerm.length > 0;

        return themesWrapper
            .map((group, index) => {
                const themes = Array.isArray(group?.themeData) ? group.themeData : [];
                const filteredThemes = isSearching
                    ? themes.filter((theme) => {
                        const title = theme?.title?.toLowerCase?.() || '';
                        const details = theme?.details?.toLowerCase?.() || '';
                        return title.includes(searchTerm) || details.includes(searchTerm);
                    })
                    : themes;

                return {
                    ...group,
                    originalIndex: index,
                    themeData: filteredThemes,
                    totalThemes: themes.length,
                };
            })
            .filter((group) => !isSearching || group.themeData.length > 0);
    }, [themesWrapper, normalizedThemeSearch]);

    const visibleThemesCount = useMemo(
        () => filteredThemeGroups.reduce((count, group) => count + group.themeData.length, 0),
        [filteredThemeGroups]
    );

    const isSearchingThemes = normalizedThemeSearch.length > 0;

    const toggleGroup = (index) => {
        setExpandedGroups((prevState) =>
            prevState.map((isExpanded, i) => (i === index ? !isExpanded : isExpanded))
        );
    };

    const handleThemeSearchChange = (event) => {
        setThemeSearchTerm(event.target.value);
    };

    const clearThemeSearch = () => {
        setThemeSearchTerm('');
    };

    const currencyFormatter = useMemo(() => new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2,
    }), []);

    const formatAmount = useCallback((value) => {
        const numeric = typeof value === 'number' ? value : Number(value);
        const safeValue = Number.isFinite(numeric) ? numeric : 0;
        return currencyFormatter.format(safeValue);
    }, [currencyFormatter]);

    const paymentSnapshot = useMemo(() => {
        const toNumber = (value) => {
            if (value === null || value === undefined || value === '') {
                return 0;
            }
            const numeric = Number(value);
            return Number.isFinite(numeric) ? numeric : 0;
        };

        const lineItems = Array.isArray(invoiceDataMaster?.productData) ? invoiceDataMaster.productData : [];
        let subtotal = 0;
        let taxTotal = 0;
        let discountTotal = 0;

        lineItems.forEach((item) => {
            const qty = toNumber(item?.qty) || 1;
            const price = toNumber(item?.price);
            const gstValue = toNumber(item?.gstValue);
            const lineTotal = toNumber(item?.total);

            const baseAmount = price * qty;
            const effectiveLineTotal = lineTotal || baseAmount + gstValue;
            const netAfterTax = effectiveLineTotal - gstValue;
            const discountAmount = Math.max(baseAmount - netAfterTax, 0);

            subtotal += netAfterTax;
            taxTotal += gstValue;
            discountTotal += discountAmount;
        });

        const computedGrand = subtotal + taxTotal;
        const masterGrand = toNumber(invoiceDataMaster?.grandTotal);
        const roundOffValue = toNumber(invoiceDataMaster?.roundOffValue);
        const usesRoundOff = Boolean(invoiceDataMaster?.isRoundingOff);
        const grandTotal = (masterGrand || computedGrand) + (usesRoundOff ? roundOffValue : 0);

        const collections = Array.isArray(invoiceDataMaster?.collectionData)
            ? invoiceDataMaster.collectionData
            : [];

        const paidTotalFromCollections = collections.reduce((sum, entry) => {
            return sum + toNumber(entry?.amount ?? entry?.collectionAmount);
        }, 0);

        const fallbackPaid = toNumber(invoiceDataMaster?.amountCollected);
        const paidTotal = paidTotalFromCollections || fallbackPaid;

        const rawDue = invoiceDataMaster?.remainingAmount != null
            ? toNumber(invoiceDataMaster.remainingAmount)
            : grandTotal - paidTotal;

        const normalizedDue = Math.abs(rawDue) < 0.5 ? 0 : rawDue;

        const status = (() => {
            if (normalizedDue === 0) {
                return { tone: 'success', label: 'Paid in full' };
            }

            if (normalizedDue < 0) {
                return { tone: 'info', label: 'Advance collected' };
            }

            return { tone: 'warning', label: 'Payment pending' };
        })();

        return {
            subtotal,
            taxTotal,
            discountTotal,
            grandTotal,
            paidTotal,
            dueAmount: normalizedDue,
            status,
        };
    }, [invoiceDataMaster]);

    const outstandingAmount = paymentSnapshot.dueAmount > 0 ? paymentSnapshot.dueAmount : 0;
    const balanceLabel = paymentSnapshot.dueAmount < 0
        ? 'Advance balance'
        : paymentSnapshot.dueAmount === 0
            ? 'No balance due'
            : 'Outstanding balance';

    const balanceValue = formatAmount(
        paymentSnapshot.dueAmount < 0
            ? Math.abs(paymentSnapshot.dueAmount)
            : outstandingAmount
    );

    const balanceNote = paymentSnapshot.dueAmount > 0
        ? 'Collect this amount to settle the invoice.'
        : paymentSnapshot.dueAmount < 0
            ? 'Customer has paid ahead of time.'
            : 'Invoice is fully paid.';

    const statusIcon = paymentSnapshot.status.tone === 'success'
        ? <CheckCircle2 size={18} />
        : paymentSnapshot.status.tone === 'info'
            ? <Sparkles size={18} />
            : <Clock3 size={18} />;

    // Function to calculate contrast text color
    const generateContrastColor = (bgColor) => {
        return tinycolor(bgColor).isLight() ? "#000000" : "#FFFFFF";
    };
    // Generate the palette for a single base color
    const generatePaletteFromBase = (baseColor) => {
        const textColor = generateContrastColor(baseColor);

        const tableHeaderColor = tinycolor(baseColor).darken(10).toHexString();
        const tableHeaderTextColor = generateContrastColor(tableHeaderColor);

        const tableBodyBackgroundColor = tinycolor(baseColor).lighten(5).toHexString();
        const tableBodyTextColor = generateContrastColor(tableBodyBackgroundColor);
        const tableBodyBorderColor = tinycolor(baseColor).darken(15).toHexString();

        const primaryButtonColor = tinycolor(baseColor).complement().lighten(10).toHexString();
        const primaryButtonTextColor = generateContrastColor(primaryButtonColor);

        const secondaryButtonColor = tinycolor(baseColor).spin(30).darken(10).toHexString();
        const secondaryButtonTextColor = generateContrastColor(secondaryButtonColor);

        const tertiaryButtonColor = tinycolor(baseColor).spin(-30).lighten(15).toHexString();
        const tertiaryButtonTextColor = generateContrastColor(tertiaryButtonColor);

        const invoiceNotesColor = tinycolor(baseColor).desaturate(20).lighten(25).toHexString();
        const sectionDividingLineColor = tinycolor(baseColor).darken(20).setAlpha(0.5).toRgbString();

        const invoiceHeaderBackgroundColor = tinycolor(baseColor).darken(5).toHexString();
        const invoiceHeaderTextColor = generateContrastColor(invoiceHeaderBackgroundColor);

        const footerBackgroundColor = tinycolor(baseColor).darken(8).toHexString();
        const footerTextColor = generateContrastColor(footerBackgroundColor);

        const warningTextColor = tinycolor(baseColor).spin(120).saturate(40).toHexString();
        const successTextColor = tinycolor(baseColor).spin(-120).saturate(50).toHexString();

        const watermarkColor = tinycolor(baseColor).lighten(40).setAlpha(0.1).toRgbString();

        const accentLineColor = tinycolor(baseColor).lighten(15).toHexString();

        return {
            backgroundColor: baseColor,
            textColor,
            tableHeaderColor,
            tableHeaderTextColor,
            tableBodyBackgroundColor,
            tableBodyTextColor,
            tableBodyBorderColor,
            primaryButtonColor,
            primaryButtonTextColor,
            secondaryButtonColor,
            secondaryButtonTextColor,
            tertiaryButtonColor,
            tertiaryButtonTextColor,
            invoiceNotesColor,
            sectionDividingLineColor,
            invoiceHeaderBackgroundColor,
            invoiceHeaderTextColor,
            footerBackgroundColor,
            footerTextColor,
            warningTextColor,
            successTextColor,
            watermarkColor,
            accentLineColor,
        };
    };

    // Generate unique base colors
    const generateBaseColors = (count, existingColors = new Set()) => {
        const randomColor = () =>
            `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0")}`;
        const baseColors = [];

        while (baseColors.length < count) {
            const newColor = randomColor();
            if (!existingColors.has(newColor)) {
                baseColors.push(newColor);
                existingColors.add(newColor);
            }
        }

        return baseColors;
    };

    // const handleGenerateMore = () => {
    //     const baseColors = generateBaseColors(5, new Set(palette.map((p) => p.backgroundColor)));
    //     const newPalettes = baseColors.map((baseColor) => generatePaletteFromBase(baseColor));
    //     setPalette((prev) => [...prev, ...newPalettes]);
    // };

    const handleGenerateMore = (userBaseColor = null) => {
        // Validate the user-provided base color (if any)
        const isValidHex = (color) =>
            /^#([0-9A-F]{3}){1,2}$/i.test(color);

        const baseColors = userBaseColor && isValidHex(userBaseColor)
            ? [userBaseColor] // Use the user-provided base color
            : generateBaseColors(5, new Set(palette.map((p) => p.backgroundColor))); // Generate colors automatically if no valid input

        // Generate palettes from the base colors
        const newPalettes = baseColors.map((baseColor) =>
            generatePaletteFromBase(baseColor)
        );

        // Update the palette state
        setPalette((prev) => [...prev, ...newPalettes]);
    };


    useEffect(() => {
        handleGenerateMore(); // Generate initial palette
    }, []);


    const getInvoiceData = async () => {
        console.log('getting invoice data...')
        const getInvoiceDataResponse = await fetch(BASE_URL_API + "getInvoiceData",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    sessionIdentifier: sessionIdentifier
                })
            });

        if (!getInvoiceDataResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getInvoiceDataRespo = await getInvoiceDataResponse.json()
            if (getInvoiceDataRespo.status === "success") {
                setInvoiceDataMaster(getInvoiceDataRespo?.response)
            } else {
                if (getInvoiceDataRespo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
            // console.log("fetched data end")
            console.log(getInvoiceDataRespo)
            // console.log("fetched data end")
        }
    }

    const sendInvoiceHandler = async () => {
        setIsSendingInvoice(true)
        const sendInvoiceResponse = await fetch(BASE_URL_API + "sendInvoiceNew",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    sessionIdentifier: sessionIdentifier,
                    storeName: activeStore?.storeName,
                    customerCare: activeStore?.storePrimaryPhone,
                })
            });

        if (!sendInvoiceResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const sendInvoiceRespo = await sendInvoiceResponse.json();
            if (sendInvoiceRespo.status === 'success') {
                // setInvoiceKey(sendInvoiceRespo?.response)
                toast(`Invoice shared successfully!`)
            } else {
                if (sendInvoiceRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else {
                    // setHasInvoiceShared('NOT_SHARING')
                }
            }
            console.log(sendInvoiceRespo)
        }
        setIsSendingInvoice(false)
    }
    // const sendInvoiceHandler = async () => {
    //     setIsSendingInvoice(true)
    //     const sendInvoiceResponse = await fetch(BASE_URL_API + "sendInvoice",
    //         {
    //             method: 'POST',
    //             body: JSON.stringify({
    //                 token: authCtx.token,
    //                 bookingIdentifier: sessionIdentifier
    //             })
    //         });

    //     if (!sendInvoiceResponse.ok) {
    //         console.log("Something went wrong : Server Error")
    //     } else {
    //         const sendInvoiceRespo = await sendInvoiceResponse.json();
    //         if (sendInvoiceRespo.status === 'success') {
    //             // setInvoiceKey(sendInvoiceRespo?.response)
    //             toast(`Invoice shared successfully!`)
    //         } else {
    //             if (sendInvoiceRespo.message === 'tokenExpired') {
    //                 authCtx.logout()
    //             } else {
    //                 // setHasInvoiceShared('NOT_SHARING')
    //             }
    //         }
    //         console.log(sendInvoiceRespo)
    //     }
    //     setIsSendingInvoice(false)
    // }

    const shareOptions = [
        {
            key: 'whatsapp',
            label: 'WhatsApp',
            hint: 'Send the invoice to the customer via WhatsApp.',
            icon: FaWhatsapp,
            onClick: sendInvoiceHandler,
            loading: isSendingInvoice,
        },
        {
            key: 'email',
            label: 'Email',
            hint: 'Deliver a beautifully formatted copy straight to the inbox.',
            icon: Mail,
            disabled: true,
            badge: 'Soon',
        },
        {
            key: 'sms',
            label: 'SMS',
            hint: 'Send a quick payment reminder by text message.',
            icon: MessageSquare,
            disabled: true,
            badge: 'Soon',
        },
    ];


    useEffect(() => {
        getInvoiceData()
    }, [sessionIdentifier])

    console.log(activeStore.storeIdentifier)

    const markAsCompletedHandler = async () => {
        // setIsUpdatingStatus(true)
        setIsMarkingCompleted(true)
        const updateSessionStatusResponse = await fetch(BASE_URL_API + "updateSessionStatus",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    bookingIdentifier: sessionIdentifier,
                    statusToBeUpdated: 'BOOKING_COMPLETED',
                    storeName: activeStore?.storeName,
                    storePrimaryPhone: activeStore?.storePrimaryPhone
                })
            });

        if (!updateSessionStatusResponse.ok) {
            console.log("Something went wrong : Server Error");
        } else {
            const updateSessionStatusRespo = await updateSessionStatusResponse.json();
            if (updateSessionStatusRespo.status == "success") {
                toast(`Invoice marked successfully!`)
                navigate('/invoice/create')
                // setMarkCompleted(true)
            } else {
                if (updateSessionStatusRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else {

                }
            }
            console.log(updateSessionStatusRespo);
        }
        setIsMarkingCompleted(false)
        // setIsUpdatingStatus(false)
    }

    if (activeStore === null) {
        return (
            <div>
                Please select a store!
            </div>
        )
    }


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainHeader}>
                <Link to={`/invoice/create/${sessionIdentifier}`} className={styles.backBtnWrapper}>
                    <MdChevronLeft />
                    <div>Edit Invoice</div>
                </Link>
                <div className={styles.pageTitle}>Invoice Preview</div>
                <div className={styles.markAsCompleted} >
                    {isMarkingCompleted === false ?
                        <button className={styles.markNow} onClick={() => markAsCompletedHandler()} >Mark as Completed</button>
                        :
                        <button className={styles.pleaseWait}>
                            <div className={styles.spinner}>
                                <AiOutlineLoading3Quarters size={16} />
                            </div>
                                Please wait...
                        </button>
                    }
                </div>
            </div>
            <div className={styles.mainContainer}>
                <div className={styles.leftWrapper}>
                    <div className={styles.leftContainer}>
                        {/* <div className={styles.panelHeader}>
                            <div>
                                <div className={styles.panelHeading}>Theme Library</div>
                                <div className={styles.panelSubheading}>Curated layouts to match your invoice style.</div>
                            </div>
                            <div className={styles.panelStats}>
                                <span className={styles.panelBadge}>{totalThemesCount} themes</span>
                                <span className={styles.panelBadge}>{themesWrapper.length} groups</span>
                            </div>
                        </div> */}

                        <div className={styles.activeThemeCard}>
                            <div className={styles.activeThemeLabel}>Currently applied</div>
                            <div className={styles.activeThemeTitle}>{selectedTheme?.title || 'Select a theme'}</div>
                            {selectedTheme?.details && (
                                <div className={styles.activeThemeDescription}>{selectedTheme.details}</div>
                            )}
                        </div>

                        <div className={styles.panelSearch}>
                            <div className={styles.searchField}>
                                <BiSearch size={16} className={styles.searchIcon} />
                                <input
                                    type="text"
                                    value={themeSearchTerm}
                                    onChange={handleThemeSearchChange}
                                    placeholder="Search by theme name or layout"
                                    className={styles.searchInput}
                                />
                                {themeSearchTerm && (
                                    <button
                                        type="button"
                                        className={styles.clearSearch}
                                        onClick={clearThemeSearch}
                                        aria-label="Clear theme search"
                                    >
                                        <BiX size={14} />
                                    </button>
                                )}
                            </div>
                            <div className={styles.searchMeta}>
                                {isSearchingThemes ? (
                                    <span>Showing {visibleThemesCount} of {totalThemesCount} themes</span>
                                ) : (
                                    <span>Browse groups or search to jump directly.</span>
                                )}
                            </div>
                        </div>

                        <div className={styles.themesWrapper}>
                            {filteredThemeGroups.length === 0 ? (
                                <div className={styles.emptyState}>
                                    <div>No themes match “{themeSearchTerm}”.</div>
                                    <button type="button" onClick={clearThemeSearch} className={styles.emptyStateAction}>
                                        Reset search
                                    </button>
                                </div>
                            ) : (
                                filteredThemeGroups.map((group) => {
                                    const isExpanded = isSearchingThemes || expandedGroups[group.originalIndex];

                                    return (
                                        <div key={group.themeGroupTitle} className={styles.eachThemeGroup}>
                                            <button
                                                className={styles.themeGroupTitle}
                                                onClick={() => !isSearchingThemes && toggleGroup(group.originalIndex)}
                                                aria-expanded={isExpanded}
                                                type="button"
                                                disabled={isSearchingThemes}
                                            >
                                                <div className={styles.themeGroupHeading}>
                                                    {group.themeGroupTitle}
                                                    <span className={styles.themeGroupCount}>{group.totalThemes}</span>
                                                </div>
                                                <div className={styles.themeGroupMeta}>
                                                    {!isSearchingThemes && (
                                                        isExpanded ? <BiChevronUp size={18} /> : <BiChevronDown size={18} />
                                                    )}
                                                </div>
                                            </button>
                                            <div
                                                className={isExpanded ? styles.themeDataExpanded : styles.themeDataCollapsed}
                                                role="region"
                                                aria-hidden={!isExpanded}
                                            >
                                                {group.themeData.map((theme, index) => (
                                                    <button
                                                        key={index}
                                                        className={selectedTheme === theme ? styles.themeOptionActive : styles.themeOption}
                                                        onClick={() => handleThemeSelect(theme)}
                                                        type="button"
                                                    >
                                                        <div className={styles.themeTitle}>{theme.title}</div>
                                                        {theme.details && (
                                                            <div className={styles.themeDescription}>{theme.details}</div>
                                                        )}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>

                {/* Center Wrapper: Invoice Preview */}
                <div className={styles.centerWrapper}>
                    <div
                        id="invoicePreview"
                        // Add this ID to target for PDF generation
                        className={styles.invoicePreview}
                        // style={{ backgroundColor: selectedTheme?.meta?.backgroundColor, height: '297mm' }}
                        style={{ backgroundColor: selectedTheme?.meta?.backgroundColor, height: 'auto' }}
                    >
                        {selectedTheme && (
                            <InvoiceSelector selectedPallete={selectedPallete} invoiceDataMaster={invoiceDataMaster} selectedInvoice={selectedTheme} />
                        )}
                        {!selectedTheme && <div>Please select a theme to preview the invoice.</div>}
                    </div>
                </div>

                {/* Right Wrapper: Options and Export */}
                <div className={styles.rightWrapper}>
                    <div className={styles.rightContainer}>
                        {/* <div className={styles.panelHeader}>
                            <div>
                                <div className={styles.panelHeading}>Action Center</div>
                                <div className={styles.panelSubheading}>
                                    Keep the invoice moving with quick actions.
                                </div>
                            </div>
                            <div className={styles.panelStats}>
                                {invoiceDataMaster?.paymentMode && <span className={styles.panelBadge}>{invoiceDataMaster.paymentMode}</span>}
                            </div>
                        </div> */}

                        <div className={styles.rightSections}>
                            <div className={styles.sectionCard}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <div className={styles.sectionTitle}>Share Instantly</div>
                                        <div className={styles.sectionSubtitle}>Deliver the invoice without leaving this screen.</div>
                                    </div>
                                </div>
                                <div className={styles.sectionBody}>
                                    <div className={styles.shareGrid}>
                                        {shareOptions.map((option) => {
                                            const IconComponent = option.icon;
                                            const isDisabled = option.disabled || option.loading;
                                            return (
                                                <button
                                                    type="button"
                                                    key={option.key}
                                                    className={`${styles.shareTile} ${isDisabled ? styles.shareTileDisabled : ''}`}
                                                    onClick={() => {
                                                        if (!isDisabled && option.onClick) {
                                                            option.onClick();
                                                        }
                                                    }}
                                                    disabled={isDisabled}
                                                    title={option.disabled ? 'Coming soon' : undefined}
                                                >
                                                    <div className={styles.shareTileHeader}>
                                                        {option.loading ? (
                                                            <div className={styles.shareTileLoading}>
                                                                <AiOutlineLoading3Quarters size={18} />
                                                            </div>
                                                        ) : (
                                                            <IconComponent size={18} />
                                                        )}
                                                        <span>{option.label}</span>
                                                        {option.badge && <span className={styles.shareTileBadge}>{option.badge}</span>}
                                                    </div>
                                                    <div className={styles.shareTileHint}>{option.hint}</div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className={styles.summaryCard}>
                                <div className={styles.summaryTopRow}>
                                    <div className={styles.summaryMain}>
                                        <span className={styles.summaryLabel}>{balanceLabel}</span>
                                        <div className={styles.summaryValue}>{balanceValue}</div>
                                    </div>
                                    <div className={`${styles.statusChip} ${
                                        paymentSnapshot.status.tone === 'success'
                                            ? styles.statusSuccess
                                            : paymentSnapshot.status.tone === 'info'
                                                ? styles.statusInfo
                                                : styles.statusWarning
                                    }`}>
                                        {statusIcon}
                                        <span>{paymentSnapshot.status.label}</span>
                                    </div>
                                </div>
                                <div className={styles.summaryFootnote}>{balanceNote}</div>
                            </div>

                            <div className={styles.tipCard}>
                                <Sparkles size={16} />
                                <span>Set a default theme in Invoice Settings to speed up future previews.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default InvoicePreviewer;
